// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"styles_formTitle__E30FH","formLinks":"styles_formLinks__13neX","noAccountText":"styles_noAccountText__f1SQR","submitBtn":"styles_submitBtn__2ynnB"};